<section id="pod-data">
  <div>
    <h1>Sensor Management</h1>
  </div>
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">Sensor Failures</p-tab>
      <p-tab value="1">Sensor Life</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <sensor-failure-management-grid></sensor-failure-management-grid>
      </p-tabpanel>
      <p-tabpanel value="1">
        <sensor-warranty-check-grid></sensor-warranty-check-grid>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</section>
